// extracted by mini-css-extract-plugin
export default {"iconShop":"SVG_iconShop__wHNnq","iconStars":"SVG_iconStars__ecsyz","iconClose":"SVG_iconClose__g4FH+","iconForm":"SVG_iconForm__I2QA1"};